export const REQUEST_STATUS = {
	LOADING: "LOADING",
	LOADED: "LOADED",
	ERROR: "ERROR"
}